module.exports = __webpack_public_path__ + "img/myblu-logo.a7e00b30.svg";